// Country conditions card. Reads matter.workspace.coi.

import type { COIShape } from "../workspace-shapes";

interface Props {
  coi: COIShape | undefined;
}

export function COICard({ coi }: Props) {
  return (
    <div className="cc-card">
      <div className="cc-card-head">
        <div className="cc-card-title">Country conditions</div>
        <div className="cc-card-sub">· COI exhibits</div>
      </div>
      <div style={{ padding: "14px 18px 16px" }}>
        {!coi ? (
          <div style={{ fontSize: 12.5, color: "var(--muted)", marginBottom: 12 }}>
            No country-conditions packet built yet.
          </div>
        ) : (
          <>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 10,
                marginBottom: 12,
              }}
            >
              <div>
                <div
                  style={{
                    fontSize: 9.5,
                    fontWeight: 700,
                    textTransform: "uppercase",
                    letterSpacing: "0.08em",
                    color: "var(--muted)",
                  }}
                >
                  Sources
                </div>
                <div
                  style={{
                    fontVariantNumeric: "tabular-nums",
                    fontSize: 16,
                    fontWeight: 700,
                  }}
                >
                  {coi.sources ?? 0}
                </div>
              </div>
              <div>
                <div
                  style={{
                    fontSize: 9.5,
                    fontWeight: 700,
                    textTransform: "uppercase",
                    letterSpacing: "0.08em",
                    color: "var(--muted)",
                  }}
                >
                  Latest
                </div>
                <div
                  style={{
                    fontVariantNumeric: "tabular-nums",
                    fontSize: 12.5,
                    fontWeight: 600,
                  }}
                >
                  {coi.latestDate ?? "—"}
                </div>
              </div>
            </div>
            {coi.primaryReports && coi.primaryReports.length > 0 && (
              <div style={{ marginBottom: 12 }}>
                <div
                  style={{
                    fontSize: 9.5,
                    fontWeight: 700,
                    textTransform: "uppercase",
                    letterSpacing: "0.08em",
                    color: "var(--muted)",
                    marginBottom: 6,
                  }}
                >
                  Primary reports
                </div>
                <ul style={{ margin: 0, paddingLeft: 14, fontSize: 12 }}>
                  {coi.primaryReports.map((r, i) => (
                    <li key={i} style={{ marginBottom: 2 }}>
                      {r}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </>
        )}
        <button
          style={{
            width: "100%",
            padding: "8px 12px",
            borderRadius: 6,
            background: "var(--pa-accent-strong, var(--muted))",
            color: "#fff",
            fontSize: 12,
            fontWeight: 600,
          }}
        >
          {coi ? "Update COI packet →" : "Generate COI →"}
        </button>
      </div>
    </div>
  );
}
